export const locale = {
    lang: 'tr',
    data: {
        'NAV': {
            'APPLICATIONS': 'Programlar',
            'WELCOME'        : {
                'TITLE': 'Örnek',
                'BADGE': '15'
            }
        }
    }
};
